<template>
  <div>
    <MyTransition :myName="'up'">
      <Popup v-if="popupStatus">
        <PopupCheck v-if="popup == 'check'" :text="successText" @go="popupAction" @cancel="poupupEnter"></PopupCheck>
        <PopupSuccess v-if="popup == 'success'" :text="successText" @check="poupupEnter"></PopupSuccess>
        <PopupError v-if="popup == 'error'" :text="successText" @check="poupupEnter"></PopupError>
      </Popup>
    </MyTransition>
    <div class="search_block">
      <Search :filed="searchField" :searchAction="searchAction" :searchStatus="searchStatus"></Search>
    </div>
    <div class="costruction table_outter_block" style="height: calc(100vh - 100px)">
      <div class="update_btn flex flex_end">
        <button class="btn_warning" @click="updateUOF">
          <i class="el-icon-refresh-left"></i>更新UOF狀態
        </button>
      </div>
      <Loading part></Loading>
      <div v-if="tableData.length !== 0">
        <PersonalTable>
          <TableThead :thead="clearThead" :thead_scroll="thead_scroll" slot="thead" @tableSort="tableSort"
            @eventGetHeight="eventGetHeight"></TableThead>
          <div class="personal_data_table" slot="tbody" :style="`top:${table_head_heigh}px;  height:calc(100vh - ${330 - table_head_heigh
      }px);`" @scroll="scrollEvent">
            <table>
              <colgroup>
                <col v-for="(th, index) in clearThead" :key="index" :width="th.width" />
              </colgroup>
              <tbody>
                <template v-for="(data, index) in pageData">
                  <tr :key="`application_${index}`">
                    <template v-for="(th, th_index) in clearThead">
                      <!--展開每日施工單-->
                      <td :class="th.align == 'center'
      ? 'text_center'
      : false
      " :key="`info_${th_index}`" v-if="th.value == 'info'">
                        <el-button class="info_icon" type="text" @click="
      openWork(data, index)
      ">
                          <i class="el-icon-more"></i>
                        </el-button>
                      </td>
                      <!--承攬商id--->
                      <td :class="th.align == 'center'
      ? 'text_center'
      : false
      " :key="`vendor_id_${th_index}`" v-else-if="th.value == 'vendor_id'
      ">
                        {{
      labelTransform({
        key: th.value.split(
          "_"
        )[0],
        data: data[th.value],
        inner_key: [
          "vendor_id",
        ],
      })
    }}
                      </td>
                      <!-- 連結 -->
                      <td :class="th.align == 'center'
      ? 'text_center'
      : false
      " class="uof_link" @click="openOrder(data)" :key="`uof_${th_index}`" v-else-if="th.value == 'link'">
                        <button class="icon_btn btn_primary">
                          <i class="el-icon-link"></i>
                        </button>
                      </td>

                      <!--是否結案-->
                      <td :class="th.align == 'center'
      ? 'text_center'
      : false
      " :key="`state_${th_index}`" v-else-if="th.value == 'finish'">
                        <template v-if="data.status !== '簽核中'
      ">
                          <p class="blue">
                            <i class="el-icon-success"></i>
                          </p>
                        </template>
                        <template v-else><i class="el-icon-error"></i></template>
                      </td>
                      <!--承辦人員-->
                      <!-- <td :class="th.align == 'center'
      ? 'text_center'
      : false
      " :key="`employee_${th_index}`" v-else-if="th.value == 'employee_id'
      ">
                        {{
      labelTransform({
        key: th.value.split(
          "_"
        )[0],
        data: data[th.value],
        inner_key: ["id"],
      })
    }}
                      </td> -->
                      <!--陣列-->
                      <td class="table_array" :class="th.align == 'center'
      ? 'text_center'
      : false
      " :key="`array_${th_index}`" v-else-if="data[th.value] &&
      Array.isArray(
        data[th.value]
      )
      ">
                        <p v-for="item in data[
      th.value
      ]" :key="item">
                          {{
      labelTransform({
        key: th.value.split(
          "_"
        )[0],
        data: item,
        inner_key: [
          "id",
          "vendor_id",
        ],
      })
    }}
                        </p>
                      </td>
                      <!--兩層object key-->
                      <td v-else-if="th.value.includes('.')
      " :key="`object_${th_index}`">
                        {{
      transfromData(
        data,
        th.value
      )
    }}
                      </td>

                      <!--default-->
                      <td :class="th.align == 'center'
        ? 'text_center'
        : false
      " :key="`data_${th_index}`" v-else>
                        {{ data[th.value] }}
                      </td>
                    </template>
                  </tr>
                  <!---展開第二層-->
                  <tr class="table_second" :key="`daliy_${index}`" v-if="inner_status &&
      inner_status_index == index
      ">
                    <td :colspan="clearThead.length">
                      <div class="table_second__innerbox">
                        <div class="item" :class="inner_thead.dependent
      ? false
      : 'independent'
      " v-for="(
                                                        inner_thead,
      inner_thead_index
                                                    ) in clearInnerThead" :key="inner_thead_index">
                          <div class="name">
                            {{ inner_thead.name }}
                          </div>

                          <!-- 連結 -->
                          <template v-if="inner_thead.value ==
      'link'
      ">
                            <button class="btn_border" @click="
      openOrder(data)
      ">
                              <i class="el-icon-link"></i>
                            </button>
                          </template>
                          <template v-else-if="inner_thead.value ==
      'employee'
      ">
                            {{ data.employee.name }}
                          </template>
                          <!--文件操作-->
                          <template v-else-if="inner_thead.value ==
      'files'
      ">
                            <div class="item">
                              <button class="btn_border" @click="
      print(data)
      ">
                                列印施工單
                              </button>
                            </div>
                            <div class="item flex">
                              <div class="inner_name">
                                {{
      data.filename
    }}
                              </div>
                            </div>
                            <div class="item upload_box" v-if="is_role ==
      'manager'
      ">
                              <input type="file" :id="`${index}_${inner_thead_index}`" multiple @change="
      upload(
        $event,
        `${index}_${inner_thead_index}`,
        data.id
      )
      " />
                              <label :for="`${index}_${inner_thead_index}`" class="upload_UI"><i
                                  class="el-icon-upload2"></i>上傳備註文件</label>
                            </div>
                            <template v-if="is_role ==
      'manager'
      ">
                              <div class="item attachment flex" v-for="(
                                                                    f, f_index
                                                                ) in data[
      'attachment'
    ]" :key="f_index">
                                <div class="inner_name">
                                  {{
      f.filename
    }}
                                </div>
                                <button class="icon_btn btn_border" @click="
    link(
      `${f.path}`
    )
      ">
                                  <i class="el-icon-document"></i>
                                </button>
                                <button class="icon_btn btn_error" @click="
      deleteFile(
        data.id,
        f.id
      )
      ">
                                  <i class="el-icon-delete-solid"></i>
                                </button>
                              </div>
                            </template>
                            <!-- <div class="item flex">
                              <div class="inner_name">
                                每日工具箱會議及危害告知紀錄
                              </div>
                              <button
                                class="icon_btn btn_border"
                                v-if="data.file2"
                                @click="
                                  blankLink('toolbox', {
                                    work_id: data.id,
                                  })
                                "
                              >
                                <i class="el-icon-document"></i>
                              </button>
                              <div v-else>-</div>
                            </div>
                            <div class="item flex">
                              <div class="inner_name">
                                承攬商入廠切結書
                              </div>
                              <button
                                class="icon_btn btn_border"
                                v-if="data.file2"
                                @click="link()"
                              >
                                <i class="el-icon-document"></i>
                              </button>
                              <div v-else>-</div>
                            </div> -->
                          </template>
                          <!--施工人員-->
                          <template v-else-if="inner_thead.value ==
      'employees'
      ">
                            <p v-for="item in data[
      inner_thead
        .value
    ]" :key="item.name">
                              {{ item }}
                            </p>
                          </template>
                          <!-- <template
                            v-else-if="
                              inner_thead.value == 'supervisor'
                            "
                          >
                            {{ data[inner_thead.value].name }}
                          </template> -->
                          <!--object-->
                          <template v-else-if="inner_thead.value.includes(
      '.'
    )
      ">
                            {{
      transfromData(
        data,
        inner_thead.value
      )
    }}
                          </template>
                          <!--陣列: 特殊作業-->
                          <template v-else-if="data[
      inner_thead
        .value
      ] &&
      Array.isArray(
        data[
        inner_thead
          .value
        ]
      )
      ">
                            <p v-for="item in data[
      inner_thead
        .value
      ]" :key="item">
                              <i class="el-icon-caret-right"></i>
                              {{
      labelTransform({
        key: inner_thead.value.split(
          "_"
        )[0],
                              data: item,
                              inner_key: [
                              "id",
                              "op_id",
                              ],
                              })
                              }}
                            </p>
                          </template>

                          <template v-else>
                            {{
                            data[
                            inner_thead
                            .value
                            ]
                            }}
                          </template>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </PersonalTable>
        <el-pagination :page-size="page.size + 1" :pager-count="11" layout="prev, pager, next" :total="page.allPage"
          @current-change="pageChange"></el-pagination>
      </div>
      <div class="no_data" v-else-if="this.$store.state.loading == false">
        <i class="el-icon-warning-outline"></i>
        <p>NO Data</p>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.costruction {
  .el-icon-more {
    color: #323232;

  }

  .info_icon:hover {

    .el-icon-more {
      cursor: pointer;
      color: var(--mainColor2);

    }
  }


  .table_array {
    p {
      padding: 5px 10px;
      margin: 5px 0;
      border-radius: 5px;
      background: lighten(#682dff, 35%);
    }
  }
}

.table_second {
  &:hover {
    background: #676767 !important;
  }

  background: #676767;
  color: #fff;

  table {
    thead {
      background: transparent;
    }

    tbody {
      >tr {
        &:hover {
          background: #676767 !important;
        }
      }
    }

    .table_array {
      color: #fff;

      p {
        background: transparent;
        border: 1px solid #fff;
      }
    }
  }
}

.text_center {
  text-align: center;
}

.search_block {
  margin-top: 10px;
}

.search {
  cursor: pointer;

  >div {
    align-items: center;
  }
}

.update_btn {
  >button {
    width: 150px;
  }
}

.upload_box {
  input {
    display: none;
  }

  .upload_UI {
    margin-top: 10px;
    font-size: 13px;
    border-radius: 5px;
    cursor: pointer;
    border: 1px dashed #ccc;
    display: block;
    text-align: center;
    padding: 10px 50px;
    color: #ccc;

    &:hover {
      border: 1px solid #fff;
      color: #fff;

      i {
        color: #fff;
      }
    }
  }
}
</style>
<script>
import TableThead from "@/components/global/table/components/TableFixHead";
import PersonalTable from "@/components/global/table/PersonalTable.global";
import mixins from "@/components/mixins.js";
import Options from "@/utils/options";
import Search from "@/components/global/Search";
import Action from "@/components/global/Action";
export default {
  name: "construction-urgent",
  mixins: [mixins],
  components: {
    PersonalTable,
    TableThead,
    Search,
    Action,
  },
  data() {
    return {
      thead: [
        {
          name: "細節",
          width: "60px",
          value: "info",
          align: "center",
          role: ["manager", "vendor", "department"],
        },
        {
          name: "簽核結案",
          width: "90px",
          value: "finish",
          align: "center",
          role: ["manager", "vendor", "department"],
        },
        {
          name: "承攬商",
          width: "200px",
          value: "vendor_chinese",
          align: "center",
          role: ["manager", "department"],
        },

        {
          name: "施工原因",
          width: "220px",
          value: "reason",
          align: "left",
          role: ["manager", "vendor", "department"],
        },
        {
          name: "作業類型",
          width: "100px",
          value: "type",
          align: "left",
          role: ["manager", "vendor", "department"],
        },
        {
          name: "施工日期",
          width: "120px",
          value: "date",
          align: "left",
          role: ["manager", "vendor", "department"],
        },
      ],
      inner_status: false,
      inner_status_index: null,
      innerThead: [
        {
          name: "施工單編號",
          dependent: false,
          value: "form_id",
          align: "left",
          role: ["manager", "vendor", "department"],
        },
        {
          name: "申請日期",
          dependent: false,
          value: "apply_date",
          align: "center",
          role: ["manager", "vendor", "department"],
        },
        {
          name: "UOF表單",
          dependent: false,
          value: "link",
          align: "center",
          role: ["manager", "department"],
        },
        {
          name: "簽核狀況",
          dependent: false,
          value: "status",
          align: "left",
          role: ["manager", "vendor", "department"],
        },
        {
          name: "現在站點",
          dependent: false,
          value: "current_site",
          align: "center",
          role: ["manager", "department"],
        },
        {
          name: "承辦人員",
          dependent: false,
          value: "employee",
          align: "left",
          role: ["manager", "vendor", "department"],
        },
        {
          name: "作業類型",
          dependent: false,
          value: "type",
          align: "left",
          role: ["manager", "vendor", "department"],
        },
        {
          name: "特殊施工",
          dependent: false,
          value: "op_id",
          align: "left",
          role: ["manager", "vendor", "department"],
        },
        {
          name: "影響無塵室潔淨度",
          dependent: false,
          value: "fab",
          align: "left",
          role: ["manager", "vendor", "department"],
        },
        {
          name: "其他環境影響",
          dependent: false,
          value: "environment",
          align: "left",
          role: ["manager", "vendor", "department"],
        },
        {
          name: "作業區域",
          dependent: false,
          value: "area_id",
          align: "left",
          role: ["manager", "vendor", "department"],
        },
        {
          name: "影響潔淨度原因",
          dependent: true,
          value: "clean",
          align: "left",
          role: ["manager", "vendor", "department"],
        },
        {
          name: "影響環境類型",
          dependent: true,
          value: "environment_list",
          align: "left",
          role: ["manager", "vendor", "department"],
        },
        {
          name: "監工",
          dependent: true,
          value: "supervisor",
          align: "left",
          role: ["manager", "vendor", "department"],
        },
        {
          name: "監工電話",
          dependent: true,
          value: "phone",
          align: "left",
          role: ["manager", "vendor", "department"],
        },
        {
          name: "施工人員",
          dependent: true,
          value: "people",
          align: "left",
          role: ["manager", "vendor", "department"],
        },
        {
          name: "文件",
          dependent: true,
          value: "files",
          align: "center",
          role: ["manager", "vendor", "department"],
        },
      ],
      table_head_heigh: 50,
      thead_scroll: 0,
      tableData: [],
      innerTableData: [],
      page: {
        size: 7,
        page: 1,
        allPage: null,
      },
      options: {
        contractor: [],
        special: [],
        employee: [],
        employee_key: "name",
        area: [],
        area_key: "location",
        type: [],
        type_key: "name",
        vendor: [],
        vendor_employees: [],
        vendor_employees_key: "name",
        vendor_key: "vendor_chinese",
        op: [],
        op_key: "op_name",
      },
      searchStatus: false,
      uploadFile: [
        {
          name: "工具箱會議及危害告知",
          value: "toolbox",
        },
        {
          name: "承攬商入場切結書",
          value: "affidavit",
        },
      ],
      formData: new FormData(),
      file_list: {},
      popupStatus: false,
      successText: null,
      popup: null,
      del_data: {},
    };
  },
  computed: {
    searchField() {
      return [
        {
          label: "施工開始時間",
          value: "start_date",
          type: "date",
          options: null,
        },
        {
          label: "施工結束時間",
          value: "end_date",
          type: "date",
          options: null,
        },
        {
          label: "表單狀況",
          value: "status",
          type: "select",
          options: [
            {
              label: "同意",
              value: "同意",
            },
            {
              label: "否決",
              value: "否決",
            },
            {
              label: "作廢",
              value: "作廢",
            },
            {
              label: "簽核中",
              value: "簽核中",
            },
          ],
          options_value: "value",
          options_label: "label",
        },
      ];
    },
    pageData() {
      const list = [];
      for (
        let i = this.page.size * (this.page.page - 1);
        i < this.page.page * this.page.size;
        i++
      ) {
        if (this.tableData[i]) {
          list.push(this.tableData[i]);
        }
      }
      return list;
    },
    clearThead() {
      return this.thead.filter((el) => {
        return el.role.includes(this.is_role);
      });
    },
    clearInnerThead() {
      return this.innerThead.filter((el) => {
        return el.role.includes(this.is_role);
      });
    },
  },
  methods: {
    scrollEvent(el) {
      this.thead_scroll = el.target.scrollLeft;
    },
    eventGetHeight(height) {
      this.table_head_heigh = height;
    },
    tableSort(sort_attr) {
      //關閉展開細向
      this.inner_status = false;
      this.inner_status_index = null;
      if (sort_attr.includes("_sort")) {
        //順排
        const attr = sort_attr.split("_sort")[0];
        this.tableData = this.isSort({
          data: this.tableData,
          attr: attr,
          type: "sort",
        });
      } else {
        //逆排
        this.tableData = this.isSort({
          data: this.tableData,
          attr: sort_attr,
          type: "reverse",
        });
      }
    },
    pageChange(value) {
      this.page.page = value;
      //改變頁數先關閉展開係向
      this.inner_status = false;
      this.inner_status_index = null;
    },
    getSpecialOption() {
      this.$http.api.admin.specialOperation().then((res) => {
        this.options.specialList = res.data;
      });
    },
    getData(search) {
      this.$store.commit("loadingAction", true);
      this.$http.api.admin.getUrgent({ params: search }).then((res) => {
        this.searchStatus = false;
        this.page.allPage = res.data.length;
        this.tableData = res.data;
        this.$store.commit("loadingAction", false);
      });
    },
    labelTransform({ key, inner_key, data, raw_data }) {
      console.log("key:", key, "inner_key:", inner_key, "data:", data);
      const item = this.options[key].find((el) => {
        for (let el_key in el) {
          if (inner_key.includes(el_key)) {
            return data == el[el_key];
          }
        }
      });
      if (item) {
        return item[this.options[`${key}_key`]];
      }
    },
    openWork(data, index) {
      if (
        this.inner_status_index !== null &&
        this.inner_status_index == index
      ) {
        //代表已經開啟且同一個，要關閉
        this.inner_status = false;
        this.inner_status_index = null;
      } else {
        this.inner_status = true;
        this.inner_status_index = index;
      }
    },
    setInnerData(id) {
      return this.innerTableData.filter((el) => {
        return el.application_id == id;
      });
    },
    setTableKey(key) {
      if (key.includes("_")) {
        return key.split("_")[0];
      } else {
        return key;
      }
    },
    openOrder(item) {
      window.open(item.link, "_blank");
    },
    searchAction(search) {
      this.searchStatus = true;
      this.getData(search);
    },
    print(data) {
      let obj = {
        id: data.id,
        type: "urgent",
      };
      this.blankLink("print", obj);
    },
    async updateUOF() {
      await this.$http.api.admin.updateUrgent();
      this.getData({});
    },
    upload(e, file_type, id) {
      console.log(e.target.files);
      this.$set(this.file_list, file_type, e.target.files[0].name);
      //檔案是複數的
      if (e.target.files.length !== 0) {
        e.target.files.forEach((el) => {
          this.formData.append("attachment[]", el);
        });
      }
      console.log("施工單ID", id);
      this.$http.api.file
        .urgentUpload(id, this.formData)
        .then(() => {
          //清空
          this.formData = new FormData();
          this.getData({});
          this.popupStatus = true;
          this.successText = "上傳成功";
          this.popup = "success";
        })
        .catch((error) => {
          this.popupStatus = true;
          this.popup = "error";
          this.successText = "送出失敗";
        });
    },
    transfromData(data, th) {
      if (th.includes("[]") && th.includes(".")) {
        const innerKey = th.split("[]");
        const lastKey = innerKey[1].split(".")[1];
        return data[innerKey[0]].map((el) => {
          return el[lastKey];
        });
      } else if (th.includes(".")) {
        const innerKey = th.split(".");
        return data[innerKey[0]][innerKey[1]];
      }
    },
    popupAction() {
      this.$http.api.file
        .deleteUrgentFile(
          this.del_data["data_id"],
          this.del_data["file_id"]
        )
        .then(() => {
          this.popupStatus = true;
          this.successText = "刪除成功";
          this.popup = "success";
          this.getData({});
        })
        .catch((error) => {
          this.popupStatus = true;
          this.popup = "error";
          this.successText = "送出失敗";
        });
    },
    deleteFile(data_id, file_id) {
      this.popupStatus = true;
      this.successText = "確定刪除嗎";
      this.popup = "check";
      this.del_data["data_id"] = data_id;
      this.del_data["file_id"] = file_id;
    },
    poupupEnter() {
      this.popupStatus = false;
    },
  },
  async created() {
    this.$store.commit("loadingAction", null);
    if (this.is_role !== "vendor") {
      this.options.vendor = await Options.getVendor();
      this.options.employee = await Options.getDepartmentEmployee();
    }
    this.options.area = await Options.getArea();
    this.options.vendor_employees = await Options.getVenderEmployee();
    this.options.type = await Options.constructionType();
    this.options.op = await Options.getSpecialOperation();
    this.getData({});
  },
};
</script>
